import { create } from 'zustand';

export interface FigureEditorUiState {
  canvasZoom: number;
  gridVisible: boolean;
  rulersVisible: boolean;
  showPanelLabels: boolean;
  showPanelBorders: boolean;
  previewAtJournalSize: boolean;
}

const DEFAULT_UI_STATE: FigureEditorUiState = {
  canvasZoom: 1,
  gridVisible: false,
  rulersVisible: false,
  showPanelLabels: true,
  showPanelBorders: true,
  previewAtJournalSize: false,
};

// Load initial state from localStorage
const loadInitialState = (): FigureEditorUiState => {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem('figure-editor-ui-state');
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        return { ...DEFAULT_UI_STATE, ...parsed };
      } catch {
        // Invalid JSON, use defaults
      }
    }
  }
  return DEFAULT_UI_STATE;
};

interface FigureEditorUiStore extends FigureEditorUiState {
  setZoom: (zoom: number) => void;
  toggleGrid: () => void;
  toggleRulers: () => void;
  updateState: (updates: Partial<FigureEditorUiState>) => void;
}

export const useFigureEditorUiState = create<FigureEditorUiStore>((set, get) => ({
  ...loadInitialState(),
  
  setZoom: (zoom: number) => {
    console.log('🔍 [useFigureEditorUiState] setZoom called with:', zoom);
    const newState = { ...get(), canvasZoom: zoom };
    set({ canvasZoom: zoom });
    if (typeof window !== 'undefined') {
      localStorage.setItem('figure-editor-ui-state', JSON.stringify(newState));
      console.log('🔍 [useFigureEditorUiState] Saved to localStorage:', newState);
    }
  },
  
  toggleGrid: () => {
    const newState = { ...get(), gridVisible: !get().gridVisible };
    set({ gridVisible: newState.gridVisible });
    if (typeof window !== 'undefined') {
      localStorage.setItem('figure-editor-ui-state', JSON.stringify(newState));
    }
  },
  
  toggleRulers: () => {
    const newState = { ...get(), rulersVisible: !get().rulersVisible };
    set({ rulersVisible: newState.rulersVisible });
    if (typeof window !== 'undefined') {
      localStorage.setItem('figure-editor-ui-state', JSON.stringify(newState));
    }
  },
  
  updateState: (updates: Partial<FigureEditorUiState>) => {
    console.log('🔍 [useFigureEditorUiState] updateState called with updates:', updates);
    const newState = { ...get(), ...updates };
    console.log('🔍 [useFigureEditorUiState] State updated:', { prev: get(), newState });
    set(updates);
    if (typeof window !== 'undefined') {
      localStorage.setItem('figure-editor-ui-state', JSON.stringify(newState));
      console.log('🔍 [useFigureEditorUiState] Saved to localStorage:', newState);
    }
  },
}));

